import { useEffect, useState } from "react";
import { webUrlNode } from "../../constants/appInfo";

import TenantRechargeHistory from "./TenantRechargeHistory";
import TenantEmailCreditDashboard from "./TenantEmailCreditDashboard";
import TenantSMSCreditDashboard from "./TenantSMSCreditDashboard";

export default function TenantCreditDashboard({ channel }) {



  return (
    <div style={{ paddingTop: 100 }}>

     <TenantEmailCreditDashboard />
     

     <TenantSMSCreditDashboard />


     <TenantRechargeHistory />
    
    </div>
  );
}
